import gsap from 'gsap';

const score = document.querySelectorAll('[data-game-details]');

export default class ScoreBoard {
    constructor() {
        this.openScore();
    }

    openScore() {
        gsap.timeline()
            .to('.starter', {autoAlpha: 0, scale: 2, duration: 0.7})
            .to(score, {autoAlpha: 1})
    }
}